import React from 'react';
import classnames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';

const T_PREFIX = 'freelancer_page.contact';

/** @param {number} hours */
const getRespondTimeText = (hours) => (hours === 1 ? `${T_PREFIX}.responds_in_hour` : `${T_PREFIX}.responds_in_hours`);

/** @type {React.FC<{className?: string; respondHours?: number}>} */
export const RespondTimeInfo = ({ className, respondHours }) => {
    if (!respondHours) {
        return null;
    }

    return (
        <div className={classnames(className, 'flex flex-center responds-info')}>
            <span>
                <I18n k={getRespondTimeText(respondHours)} params={{ hour: respondHours }} />
            </span>
        </div>
    );
};
